import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingCacheExcludeActions from '../actions/hosting-cache-exclude.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {LoadCacheExclude} from "../actions";

@Injectable()
export class HostingCacheExcludeEffects {

  loadCacheExclude = createEffect(() => this._actions$.pipe(
    ofType(hostingCacheExcludeActions.LOAD_CACHE_EXCLUDE),
    mergeMap((action: LoadCacheExclude) => {
      return this._hostingService.hostingToolsGetExcludePages(action.payload)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingCacheExcludeActions.LoadCacheExcludeSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new hostingCacheExcludeActions.LoadCacheExcludeFail(response.message);
          })
        );
    })
  ));

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }


}
